import "flowbite";
import "mapbox-gl/dist/mapbox-gl.css";
import posthog from "posthog-js";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App.jsx";
import GrowthBookProvider from "./config/growthbook/growthbook.jsx";
import "./i18n";
import "./index.css";
import { persistor, store } from "./store/store";

const POSTHOG_PRODUCTION_HOST = "optiview2.oneopticloud.com";

if (window.location.hostname === POSTHOG_PRODUCTION_HOST) {
	posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
		api_host: import.meta.env.VITE_POSTHOG_HOST,
		person_profiles: "identified_only",
		disable_session_recording: true,
		enable_recording_console_log: false,
	});
}
ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<HelmetProvider>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<GrowthBookProvider>
						<App />
					</GrowthBookProvider>
				</PersistGate>
			</Provider>
		</HelmetProvider>
	</React.StrictMode>,
);
